export default __webpack_public_path__ + "static/media/issuer-behance.53519986.svg";